module.exports = __webpack_public_path__ + "static/media/gameEnding_3.7ca17f06.mp3";